import React, { FC } from 'react';
import { TimesheetHourTypeProps } from './types';
import { map } from 'lodash';
import { Box, Text } from '@bechtel/gds';
import { FieldArray } from 'formik';
import { TimeEntry } from './time-entry';
import { TimesheetHourContainerStyled } from './styled';
import { TotalHeaderColumnStyled } from '~/detail/styled';
import { useTimesheet } from '~/detail/context';
import { find } from 'lodash';
export const TimesheetHourCode: FC<TimesheetHourTypeProps> = ({ timesheetHourCodes, name }) => {
  const { hourTypes } = useTimesheet();
  return (
    <TimesheetHourContainerStyled>
      <FieldArray name={`${name}.hourCodeTimeEntry`} validateOnChange={false}>
        {(arrayHelpers) => {
          return (
            <>
              {map(timesheetHourCodes, (timesheetHourCode, hourCodeIndex) => {
                const hourType = find(hourTypes, (hourType) => hourType.hourCode == timesheetHourCode.hourCode);
                return (
                  <Box
                    key={`${name}-${timesheetHourCode.hourCode}-${hourCodeIndex}`}
                    style={{ backgroundColor: 'white' }}
                  >
                    <TotalHeaderColumnStyled css={{ position: 'sticky', zIndex: 1, left: 0, background: 'white' }}>
                      <Box
                        alignItems={{ sm: 'center' }}
                        justifyContent={{ sm: 'flex-end' }}
                        flexGrow={{ sm: 1 }}
                        pr={{ sm: '300' }}
                      >
                        <Text size="400">{`${hourType?.description} (${timesheetHourCode.hourCode})`}</Text>
                      </Box>
                    </TotalHeaderColumnStyled>
                    <Box py={{ sm: '300' }}>
                      {map(timesheetHourCode.timeEntries, (timeEntry, index: number) => {
                        return (
                          <TimeEntry
                            key={`${name}-${timesheetHourCode.hourCode}-${hourCodeIndex}-${timeEntry.crewMemberId}`}
                            timeEntryInput={timeEntry}
                            formikParentFieldName={`${name}.hourCodeTimeEntry.${hourCodeIndex}.timeEntries.${index}`}
                          ></TimeEntry>
                        );
                      })}
                    </Box>
                  </Box>
                );
              })}
            </>
          );
        }}
      </FieldArray>
    </TimesheetHourContainerStyled>
  );
};
